import { tags } from '../tagNames';
import { useUserTags } from '../useUserTags';

export const useIsPromoEventEnabled = (): [boolean, boolean] => {
	const { userTags, isLoading } = useUserTags();
	const enabled =
		userTags.includes(tags.a) ||
		userTags.includes(tags.i) ||
		userTags.includes(tags.u);

	return [enabled, isLoading];
};
